import { getRegion } from '../helpers/getRegion';

const partners = {
  com: [
    'boxing.jpeg',
    'bahcesehir.jpeg',
    'lovefest.jpeg',
    'maccabi.jpeg',
    'time_less.jpeg',
    'hapoel.jpeg',
    'MR.png',
  ],
  rs: [
    'boxing.jpeg',
    'bahcesehir.jpeg',
    'lovefest.jpeg',
    'maccabi.jpeg',
    'time_less.jpeg',
    'hapoel.jpeg',
    'MR.png',
  ],
  fr: [],
  nl: [],
};

export const getPartnersLogos = () => {
  const domen = getRegion();

  switch (domen) {
    case 'rs':
      return partners.rs;

    case 'fr':
      return partners.fr;

    case 'nl':
      return partners.nl;

    default:
      return partners.com;
  }
};
